module.exports = __webpack_public_path__ + "assets/devices/unknown-409fe788dc80115cd5cb2be84f9a15a8.svg";